<script>
import SocialInteractions from '../social-interactions/social-interactions.vue';
import SocialLinks from '../social-links/social-links.vue';

export default {
  components: {
    SocialInteractions,
    SocialLinks
  }
};
</script>

<template>
<div class="social-interactions">
  <social-interactions></social-interactions>
  <social-links></social-links>
</div>
</template>

<style scoped>
.social-interactions {
  display: flex;
  height: 53px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// social-footer.vue?335821a9